import { createFileRoute, Outlet } from '@tanstack/react-router';
import { requireScope } from '~/auth/utils';

export const Route = createFileRoute('/_authenticated/staff')({
    beforeLoad: async ({ context: { auth } }) => {
        requireScope(auth, undefined);
    },
    component: () => <Outlet />,
});
